<template>
  <div>
    <!-- <transition name="fade" v-if="!loaderFinished"> -->
    <SiteLoader
      key="1"
      v-if="!loaderFinished"
      @setLoaderFinished="setLoaderFinished"
    />
    <!-- </transition> -->
    <div id="router-view-container" v-else>
      <router-view />
      <GalleryModal
        v-if="global.galleryData !== null"
        :productData="global.galleryData"
        :modalId="'gallerymodal'"
      />
    </div>
  </div>
</template>

<script>
import SiteLoader from "@/components/global/SiteLoader";
import { mapActions, mapState } from "vuex";
import GalleryModal from "@/components/global/GalleryModal";
import axios from "axios";
export default {
  name: "Layout",
  components: {
    SiteLoader,
    GalleryModal,
  },
  computed: {
    ...mapState(["global"]),
  },
  data() {
    return {
      loaderFinished: false,
    };
  },
  mounted() {
    document.title = "Cubs x Artists";
    this.setScreenWidth(window.innerWidth);
    this.setIsMobile(window.innerWidth <= 768);
    window.addEventListener(
      "resize",
      () => {
        this.setScreenWidth(window.innerWidth);
        this.setIsMobile(window.innerWidth <= 768);
      },
      false
    );
    this.trackDeviceType();
  },
  methods: {
    setLoaderFinished() {
      this.loaderFinished = true;
    },
    trackDeviceType() {
      const label = window.innerWidth >= 992 ? "Desktop" : "Mobile";
      axios
        .post(process.env.VUE_APP_API_URL + "/api/router/Tracking.php", {
          site: "common",
          action: "tracking",
          label,
          category: "Device Size",
        })
        .catch(() => {
          window.console.log("failed tracking");
        });
    },
    ...mapActions(["setScreenWidth", "setIsMobile"]),
  },
};
</script>

<style lang="scss">
#router-view-container {
  min-height: 100vh;
  min-width: 100vw;
  &.home {
    padding-top: 0px;
  }
}
/* Fade Transition */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s ease-in-out;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>

<style lang="scss">
.button {
  min-width: 145px;
  max-width: 100%;
  height: 36px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 0 12px;
  &:hover {
    cursor: pointer;
  }
  span {
    font-family: "Poppins-Bold";
    font-size: 13px;
    color: #ffffff;
    letter-spacing: 0;
    text-align: center;
    text-transform: uppercase;
  }
  img,
  svg {
    width: 15px;
    height: 12px;
    margin-right: 5px;
  }
}
.gray-button {
  span {
    color: #000 !important;
  }
  background-image: linear-gradient(179deg, #ffffff 0%, #ebebeb 100%);
  &:hover {
    background-image: linear-gradient(180deg, #fdfdfd 0%, #bfbfbf 100%);
  }
}
.red-button {
  background-image: linear-gradient(180deg, #e13a3e 0%, #e51318 99%);
  &:hover {
    background-image: linear-gradient(180deg, #e13a3e 0%, #bd070b 99%);
    outline: none;
    text-decoration: none;
  }
}

</style>